import { apiCall } from "../../services/api-service";

export const getSummaryListApi = async (bodyData) => {
    const response = await apiCall("post", "summary", bodyData);
    return response?.data;
};


export const exportquickApi = async (apivalue) => {
    return apiCall("post", `report/${apivalue}`, {});
};